export function fmtDate(d) {
  if (!d) return "";
  return String(d).split("T")[0];
}

export function fmtMoney(n, fractionDigits = 2) {
  const num = Number(n);
  if (!Number.isFinite(num)) return "—";
  return num.toLocaleString("en", { minimumFractionDigits: fractionDigits });
}

export function statusLabel(status) {
  if (status === "matched") return "Matched";
  if (status === "has_mismatches") return "Has mismatches";
  return status || "—";
}

export function tabLabel(tab) {
  switch (tab) {
    case "pending_resolution":
      return "Pending Resolution";
    case "ready":
      return "Ready for SAP";
    case "posted":
      return "Posted to SAP";
    case "all":
      return "All";
    default:
      return tab;
  }
}
